import { Button } from "Components";
import React from "react";
import '../Profile.scss';
import { useFormikContext } from "formik";

type Props = {
    title: string,
    btnText?: string,
    children: React.ReactNode,
    description?: string,
    parentClass?: string,
    btnDisable?: boolean,
    isLoading?: boolean,
    variant?: string;
    handleNext?: () => void,
}

const Layout = ({ title, description = '', children, parentClass = '', btnText = '', btnDisable, isLoading, variant = "default", handleNext } : Props) => {
    return <div className={`setting-section ${parentClass}`}>
        <div className="header">
            <h3>{title}</h3>
            {description && <span>{description}</span>}
        </div>
        <div className="form-section">{children}</div>
        {btnText && <div className="footer">
            <Button ghost={variant === "ghost"} shape="round" type="primary" disabled={btnDisable || isLoading} loading={isLoading} onClick={handleNext} className={btnDisable ? 'cta-disabled' : ''}>
                {btnText}
            </Button>
        </div>}
    </div>
}

export default Layout;